class $523a5a8016e4d73e$export$2e2bcd8739ae039 {
    constructor(field, label, errorElement, fieldErrorClasses, fieldClassesToRemove, labelErrorClasses, labelClassesToRemove, validators){
        this.field = field;
        this.label = label;
        this.errorElement = errorElement;
        this.fieldErrorClasses = fieldErrorClasses;
        this.fieldClassesToRemove = fieldClassesToRemove;
        this.labelErrorClasses = labelErrorClasses;
        this.labelClassesToRemove = labelClassesToRemove;
        this.isValid = true;
        this.validators = validators;
    }
    validate(fields) {
        for (const { message: message, validator: validator } of this.validators)if (!validator(this.value, fields)) {
            if (typeof message === "string") this.showError(message);
            else this.showError(message(this.value, fields));
            this.isValid = false;
            return;
        }
        if (!this.isValid) {
            this.hideError();
            this.isValid = true;
        }
    }
    showError(message) {
        this.label.classList.add(...this.labelErrorClasses);
        this.label.classList.remove(...this.labelClassesToRemove);
        this.field.classList.add(...this.fieldErrorClasses);
        this.field.classList.remove(...this.fieldClassesToRemove);
        this.errorElement.textContent = message;
    }
    hideError() {
        this.label.classList.remove(...this.labelErrorClasses);
        this.label.classList.add(...this.labelClassesToRemove);
        this.field.classList.remove(...this.fieldErrorClasses);
        this.field.classList.add(...this.fieldClassesToRemove);
        this.errorElement.textContent = "";
    }
    get value() {
        return this.field.value;
    }
    get valueAsInt() {
        return parseInt(this.field.value);
    }
}


const $ec8660b69cc48a2c$export$23fb5d946ed09522 = {
    1: 31,
    2: 28,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31
};
function $ec8660b69cc48a2c$export$83595b84fc78b9b4(id) {
    const ELEMENT = document.getElementById(id);
    if (ELEMENT === null) throw new Error(`Element with ID '${id}' is not found!`);
    return ELEMENT;
}
function $ec8660b69cc48a2c$export$491b3b23d7cb233(id) {
    return $ec8660b69cc48a2c$export$83595b84fc78b9b4(id + "Error");
}
function $ec8660b69cc48a2c$export$e029667a62135fd0(year, month = "01", day = "01") {
    return {
        year: parseInt(year),
        month: parseInt(month),
        day: parseInt(day)
    };
}
function $ec8660b69cc48a2c$export$b0932c69ff376ad3({ year: year, month: month, day: day }) {
    const CURRENT_DATE = new Date();
    let [currentYear, currentMonth, currentDay] = [
        CURRENT_DATE.getFullYear(),
        CURRENT_DATE.getMonth() + 1,
        CURRENT_DATE.getDate()
    ];
    if (currentDay < day) {
        const DAYS_OF_THE_MONTH = $ec8660b69cc48a2c$export$23fb5d946ed09522[month];
        if ($ec8660b69cc48a2c$export$553d7fa8e3805fc0(year) && month === 2) currentDay += DAYS_OF_THE_MONTH + 1;
        else currentDay += DAYS_OF_THE_MONTH;
        currentMonth -= 1;
    }
    if (currentMonth < month) {
        currentYear -= 1;
        currentMonth += 12;
    }
    return {
        year: currentYear - year,
        month: currentMonth - month,
        day: currentDay - day
    };
}
function $ec8660b69cc48a2c$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function $ec8660b69cc48a2c$var$fadeIn(element, duration) {
    let start;
    function animate(timestamp) {
        const value = (timestamp - start) / duration;
        if (value < 1) {
            element.style.opacity = value.toString();
            requestAnimationFrame((timestamp)=>animate(timestamp));
        } else element.style.opacity = "1";
    }
    return requestAnimationFrame((timestamp)=>{
        start = timestamp;
        animate(timestamp);
    });
}
function $ec8660b69cc48a2c$var$fadeOut(element, duration) {
    let start;
    function animate(timestamp) {
        const value = 1 - (timestamp - start) / duration;
        if (value > 0) {
            element.style.opacity = value.toString();
            requestAnimationFrame((timestamp)=>animate(timestamp));
        } else element.style.opacity = "0";
    }
    return requestAnimationFrame((timestamp)=>{
        start = timestamp;
        animate(timestamp);
    });
}
function $ec8660b69cc48a2c$export$488781d6b3317c32(element, value, duration, delay = 0) {
    duration = duration / 2;
    setTimeout(()=>{
        $ec8660b69cc48a2c$var$fadeOut(element, duration);
        setTimeout(()=>{
            element.textContent = value;
            $ec8660b69cc48a2c$var$fadeIn(element, duration);
        }, duration);
    }, delay);
}



function $859899880f7c914c$export$dd1bc94b04021eeb(value) {
    return value !== "";
}
function $859899880f7c914c$export$6a36341129fb3ce8(value) {
    return !/[a-z]/i.test(value);
}
function $859899880f7c914c$export$2c7d0e095c922b16(value) {
    return !/[^a-z0-9]/i.test(value);
}
function $859899880f7c914c$export$ec69a2045070f0de(value) {
    if (!/^\d{1,2}$/.test(value)) return false;
    const DAY = parseInt(value);
    return DAY > 0 && DAY <= 31;
}
function $859899880f7c914c$export$e053c0c92cded25f(value) {
    if (!/^\d{1,2}$/.test(value)) return false;
    const MONTH = parseInt(value);
    return MONTH > 0 && MONTH <= 12;
}
function $859899880f7c914c$export$b6d4c1ec1852af10(value) {
    return parseInt(value) >= 0;
}
function $859899880f7c914c$export$4038ce998e4c3f65(value) {
    return parseInt(value) <= new Date().getFullYear();
}
function $859899880f7c914c$export$7059b7e1da53b417(value, fields) {
    const CURRENT_DATE = new Date();
    if (fields[2].valueAsInt === CURRENT_DATE.getFullYear() && parseInt(value) > CURRENT_DATE.getMonth() + 1) return false;
    return true;
}
function $859899880f7c914c$export$61dd02a494dde15(value, fields) {
    const CURRENT_DATE = new Date();
    if (fields[2].valueAsInt === CURRENT_DATE.getFullYear() && fields[1].valueAsInt === CURRENT_DATE.getMonth() + 1 && parseInt(value) > CURRENT_DATE.getDate()) return false;
    return true;
}
function $859899880f7c914c$export$871608497c498473(value, fields) {
    const [, MONTH_FIELD, YEAR_FIELD] = fields;
    const MONTH_FIELD_VALUE = MONTH_FIELD.value;
    const YEAR_FIELD_VALUE = YEAR_FIELD.value;
    if ($859899880f7c914c$export$6a36341129fb3ce8(MONTH_FIELD_VALUE) || $859899880f7c914c$export$2c7d0e095c922b16(MONTH_FIELD_VALUE) || $859899880f7c914c$export$6a36341129fb3ce8(YEAR_FIELD_VALUE) || $859899880f7c914c$export$2c7d0e095c922b16(YEAR_FIELD_VALUE)) return true;
    const MONTH = MONTH_FIELD.valueAsInt;
    let addedDay = 0;
    if ((0, $ec8660b69cc48a2c$export$553d7fa8e3805fc0)(YEAR_FIELD.valueAsInt) && MONTH === 2) addedDay += 1;
    const DAYS = (0, $ec8660b69cc48a2c$export$23fb5d946ed09522)[MONTH];
    if (!DAYS) return true;
    return DAYS + addedDay >= parseInt(value);
}


function $16d5ed157b53ba01$var$init() {
    const DAY_INPUT_ID = "dayField";
    const MONTH_INPUT_ID = "monthField";
    const YEAR_INPUT_ID = "yearField";
    const FORM = (0, $ec8660b69cc48a2c$export$83595b84fc78b9b4)("form");
    const DAY_INPUT = (0, $ec8660b69cc48a2c$export$83595b84fc78b9b4)(DAY_INPUT_ID);
    const MONTH_INPUT = (0, $ec8660b69cc48a2c$export$83595b84fc78b9b4)(MONTH_INPUT_ID);
    const YEAR_INPUT = (0, $ec8660b69cc48a2c$export$83595b84fc78b9b4)(YEAR_INPUT_ID);
    const DAY_ERROR = (0, $ec8660b69cc48a2c$export$491b3b23d7cb233)(DAY_INPUT_ID);
    const MONTH_ERROR = (0, $ec8660b69cc48a2c$export$491b3b23d7cb233)(MONTH_INPUT_ID);
    const YEAR_ERROR = (0, $ec8660b69cc48a2c$export$491b3b23d7cb233)(YEAR_INPUT_ID);
    const DAY_LABEL = (0, $ec8660b69cc48a2c$export$83595b84fc78b9b4)("dayLabel");
    const MONTH_LABEL = (0, $ec8660b69cc48a2c$export$83595b84fc78b9b4)("monthLabel");
    const YEAR_LABEL = (0, $ec8660b69cc48a2c$export$83595b84fc78b9b4)("yearLabel");
    const YEARS_CONTAINER = (0, $ec8660b69cc48a2c$export$83595b84fc78b9b4)("years");
    const MONTHS_CONTAINER = (0, $ec8660b69cc48a2c$export$83595b84fc78b9b4)("months");
    const DAYS_CONTAINER = (0, $ec8660b69cc48a2c$export$83595b84fc78b9b4)("days");
    const FIELD_ERROR_CLASSES = [
        "border-light-red"
    ];
    const FIELD_CLASSES_TO_REMOVE = [
        "focus:border-purple"
    ];
    const LABEL_ERROR_CLASSES = [
        "text-light-red"
    ];
    const LABEL_CLASSES_TO_REMOVE = [
        "text-smokey-grey"
    ];
    const NO_EMPTY = {
        validator: (0, $859899880f7c914c$export$dd1bc94b04021eeb),
        message: "Field is required!"
    };
    const NO_LETTERS = {
        validator: (0, $859899880f7c914c$export$6a36341129fb3ce8),
        message: "No letters!"
    };
    const NO_SYMBOLS = {
        validator: (0, $859899880f7c914c$export$2c7d0e095c922b16),
        message: "No Symbols!"
    };
    const DAY_FIELD = new (0, $523a5a8016e4d73e$export$2e2bcd8739ae039)(DAY_INPUT, DAY_LABEL, DAY_ERROR, FIELD_ERROR_CLASSES, FIELD_CLASSES_TO_REMOVE, LABEL_ERROR_CLASSES, LABEL_CLASSES_TO_REMOVE, [
        NO_EMPTY,
        NO_LETTERS,
        NO_SYMBOLS,
        {
            validator: (0, $859899880f7c914c$export$ec69a2045070f0de),
            message: "Must be valid day."
        },
        {
            validator: (0, $859899880f7c914c$export$61dd02a494dde15),
            message: "Day must be in the past."
        },
        {
            validator: (0, $859899880f7c914c$export$871608497c498473),
            message: (value, fields)=>{
                const MONTHS = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ];
                return `${MONTHS[fields[1].valueAsInt - 1]} doesn't have ${value} days.`;
            }
        }
    ]);
    const MONTH_FIELD = new (0, $523a5a8016e4d73e$export$2e2bcd8739ae039)(MONTH_INPUT, MONTH_LABEL, MONTH_ERROR, FIELD_ERROR_CLASSES, FIELD_CLASSES_TO_REMOVE, LABEL_ERROR_CLASSES, LABEL_CLASSES_TO_REMOVE, [
        NO_EMPTY,
        NO_LETTERS,
        NO_SYMBOLS,
        {
            validator: (0, $859899880f7c914c$export$e053c0c92cded25f),
            message: "Must be valid month."
        },
        {
            validator: (0, $859899880f7c914c$export$7059b7e1da53b417),
            message: "Month must be in the past."
        }
    ]);
    const YEAR_FIELD = new (0, $523a5a8016e4d73e$export$2e2bcd8739ae039)(YEAR_INPUT, YEAR_LABEL, YEAR_ERROR, FIELD_ERROR_CLASSES, FIELD_CLASSES_TO_REMOVE, LABEL_ERROR_CLASSES, LABEL_CLASSES_TO_REMOVE, [
        NO_EMPTY,
        NO_LETTERS,
        NO_SYMBOLS,
        {
            validator: (0, $859899880f7c914c$export$b6d4c1ec1852af10),
            message: "Must be valid year."
        },
        {
            validator: (0, $859899880f7c914c$export$4038ce998e4c3f65),
            message: "Year must be in the past."
        }
    ]);
    const FIELDS = [
        DAY_FIELD,
        MONTH_FIELD,
        YEAR_FIELD
    ];
    let previousValues = [];
    FORM.addEventListener("submit", function(event) {
        event.preventDefault();
        if (FIELDS.every((field, index)=>field.value === previousValues[index])) return;
        previousValues = [];
        for (const field of FIELDS)previousValues.push(field.value);
        for (const field of FIELDS)field.validate(FIELDS);
        for (const field of FIELDS)if (!field.isValid) {
            field.field.select();
            YEARS_CONTAINER.textContent = "- -";
            MONTHS_CONTAINER.textContent = "- -";
            DAYS_CONTAINER.textContent = "- -";
            return;
        }
        const BIRTHDATE = (0, $ec8660b69cc48a2c$export$e029667a62135fd0)(YEAR_FIELD.value, MONTH_FIELD.value, DAY_FIELD.value);
        const AGE = (0, $ec8660b69cc48a2c$export$b0932c69ff376ad3)(BIRTHDATE);
        (0, $ec8660b69cc48a2c$export$488781d6b3317c32)(YEARS_CONTAINER, AGE.year.toString(), 200);
        (0, $ec8660b69cc48a2c$export$488781d6b3317c32)(MONTHS_CONTAINER, AGE.month.toString(), 200, 60);
        (0, $ec8660b69cc48a2c$export$488781d6b3317c32)(DAYS_CONTAINER, AGE.day.toString(), 200, 120);
    });
}
$16d5ed157b53ba01$var$init();


//# sourceMappingURL=index.6a5a6f01.js.map
